import { Loader } from '@googlemaps/js-api-loader'

export const map = () => {

	let el = document.querySelector('[data-address]')

	if (!el) return

	const apiKey = 'AIzaSyBMWORE3wxnMEoh4g8ChtGbM0YHsM1jcpI'

	let lat = parseFloat(el.dataset.lat),
		lng = parseFloat(el.dataset.lng),
		address = el.dataset.address

	const loader = new Loader({
		apiKey: apiKey,
		version: 'weekly',
	})

	let styles = [{ elementType: "geometry", stylers: [{ saturation: -100 }] }, { elementType: "labels.icon", stylers: [{ visibility: "off" }] }, { elementType: "labels.text.fill", stylers: [{ color: "#000000" }] }, { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] }]

	loader.load().then(() => {

		let map = new google.maps.Map(el, {
			center: { lat, lng },
			zoom: 15,
			styles: styles,
			mapTypeControl: false,
			streetViewControl: false,
			zoomControl: true,
			fullscreenControl: false
		})

		let icon = {
			url: "/wp-content/themes/indigo/dist/image/marker.png",
            scaledSize: new google.maps.Size(150, 118), // Reduced size (80% of original)
            origin: new google.maps.Point(0, 0), // Image origin
            anchor: new google.maps.Point(75, 118) // Bottom-middle of the marker points to the location
		};

		new google.maps.Marker({
			position: { lat, lng },
			map: map,
			title: address,
			icon: icon,
		})

	})
}

export default () => { }